import { AbstractControlOptions, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { Directive } from '@angular/core';

@Directive()
export abstract class EaReductionFormBuilder extends PrFormAbstract {
  generate(entity: any) {
    let options: AbstractControlOptions = {};

    return this.formBuilder.group(
      {
        id: [entity ? entity.id : null],
        type: [entity.type ? entity.type : null, Validators.required],
        reductionAmount: [
          entity.reductionAmount ? entity.reductionAmount : null,
          Validators.required,
        ],
        label: [entity.label ? entity.label : null, Validators.required],
      },
      options,
    );
  }

  extract() {
    let dto: any = {
      id: this.emptyIsNull(this.form.value.id),
      type: this.emptyIsNull(this.form.value.type),
      reductionAmount: this.emptyIsNull(this.form.value.reductionAmount),
      label: this.emptyIsNull(this.form.value.label),
    };
    return dto;
  }
}
